/**
 * What a forge has cost so far (GET /v1/forge/forges/:id/cost). Polled every
 * few seconds while a turn runs — the gateway settles each model request as
 * it finishes — so the number visibly rises; otherwise fetched once and
 * refreshed when the turn ends (the turn hook invalidates the forge detail,
 * which this key sits under).
 */
import { useQuery } from '@tanstack/react-query';
import api from '@/lib/api';
import { forgeQueryKeys } from '../api/queryKeys';

/** How often the cost is re-read while a turn runs. */
export const FORGE_COST_POLL_MS = 3000;

export function useForgeCost(forgeId: string | null, isProcessing: boolean) {
  const query = useQuery({
    queryKey: forgeQueryKeys.cost(forgeId ?? ''),
    queryFn: async () => (await api.getForgeCost(forgeId!)).cost,
    enabled: !!forgeId,
    refetchInterval: isProcessing ? FORGE_COST_POLL_MS : false,
    staleTime: 5_000,
  });
  return query.data ?? null;
}
